import {Injectable} from '@angular/core';
import {BaseService, QueryParams} from '../../../../core/abstracts/base-service.abstract';
import {ReadableAll} from '../../../../core/interfaces/base-service.interfaces';
import {BrandResponse} from '../../../../shared/services/brand.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class VehicleBrandService extends BaseService implements ReadableAll<BrandResponse> {
  protected readonly endpoint: string = 'brands';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getAll(params?: QueryParams): Observable<BrandResponse[]> {
    return this.get<BrandResponse[]>('', params);
  }
}
